<div style="width: 100%;">
    <mat-card class="box">
        <div class="divtitle">
            <span class="flex-container" style="padding: 8px;">
                <h1 class="label">{{'import.label' | transloco}}</h1>
            </span>
        </div>
    </mat-card>
</div>

<div style="width: 100%;">
    <mat-card class="box">
        <label class="infoLabel">{{ 'import.text' | transloco }}<a (click)="downloadLink()" style="color: blue;">{{'import.link' |
                transloco}}</a> </label>
        <div class="dnd">

            <form method="post" class="wrapper">
                <div class="container">
                    <input type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event)" />
                    <h2 class="dragAndDropH2">{{'import.dnd' | transloco}}</h2><!--Drag and drop file here -->
                    <label for="fileDropRef" class="browseLabel"> {{'import.browse' | transloco}}</label> <!--Browse for file-->
                </div>
                <div class="fileInfo">
                    <button class="uploadBtn" (click)="uploadFile()">{{'import.upload' | transloco}}</button>
                    <label class="filename" style="margin-top: 15px;"><strong style="font-size:17px;"> {{filename}}</strong></label>
                    <label class="error">{{errorMsg}}</label>
                </div>
            </form>
            <p style="font-size: 13px; color: slategrey;">{{ 'import.disclaimer' | transloco }}</p>
        </div>
    </mat-card>
</div>
